import { FC } from 'react';
import CapQbLogo from '../CapQbLogo';
import styles from './index.module.scss';
import { ConfigurationSettingsProps } from './types';
import MappingBox from '../MappingBox';

// For whole mapping section
const ConfigurationSettings: FC<ConfigurationSettingsProps> = (props) => {
	const {
		settingsData,
		children,
		qbSelectionObj,
		settingsChangeHandler,
		isFirstTimeSubmit,
		deleteFieldHandler,
		addFieldHandler,
		showModal,
		indirectExpenseRate,
		onChangeFieldStatus,
		onChangeFieldPriority,
	} = props;

	// useEffect(() => {
	// 	console.log('settingsData', settingsData);
	// });
	return (
		<div className={styles['configuration-settings']}>
			<div className={styles['configuration-settings__wrapper']}>
				<div className={styles['configuration-settings--logos']}>
					<CapQbLogo />
				</div>
				<div className={styles['configuration-settings__settings']}>
					{Object.values(settingsData).map(
						(singleMappingSection: any, index: number) => {
							// Skip section 5 as it will be displayed inline with section 0
							if (singleMappingSection.id === '5') {
								return null;
							}

							// Special handling for section 0 to include customer dropdown from section 5
							if (singleMappingSection.id === '0') {
								const customerSection = settingsData['5'];
								return (
									<div key={index} className={styles['section-0-with-customer']}>
										<MappingBox
											allMappingSection={settingsData}
											singleMappingSection={singleMappingSection}
											qbSelectionObj={qbSelectionObj}
											settingsChangeHandler={settingsChangeHandler}
											isFirstTimeSubmit={isFirstTimeSubmit}
											deleteFieldHandler={deleteFieldHandler}
											addFieldHandler={addFieldHandler}
											showModal={showModal}
											indirectExpenseRate={indirectExpenseRate}
											onChangeFieldStatus={onChangeFieldStatus}
											onChangeFieldPriority={onChangeFieldPriority}
											customerSection={customerSection}
										/>
									</div>
								);
							}

							return (
								<MappingBox
									key={index}
									allMappingSection={settingsData}
									singleMappingSection={singleMappingSection}
									qbSelectionObj={qbSelectionObj}
									settingsChangeHandler={settingsChangeHandler}
									isFirstTimeSubmit={isFirstTimeSubmit}
									deleteFieldHandler={deleteFieldHandler}
									addFieldHandler={addFieldHandler}
									showModal={showModal}
									indirectExpenseRate={indirectExpenseRate}
									onChangeFieldStatus={onChangeFieldStatus}
									onChangeFieldPriority={onChangeFieldPriority}
								/>
							);
						}
					)}
					{children}
				</div>
			</div>
		</div>
	);
};

export default ConfigurationSettings;
